import { Type } from 'class-transformer';
import { WFEWorkflowRawDto } from '../../../shared-workflow-module/_models/wfe-workflow-raw-dto';

export class WFEDeniedStepEditorResultDto {
    @Type(() => WFEWorkflowRawDto)
    workflow: WFEWorkflowRawDto;

    allowAdvanceFromDeniedDeleteBill: boolean;
    allowAdvanceFromDeniedReverseBill: boolean;

    allowNewLineItem: boolean;
}
